import Vue from '../../assets/vue';
import {
  normalizeProductConfig,
  formatPriceWithoutDecimals,
  calcBundlePreOrderMessage,
  calcBundleVariantsForSell,
  isBundleAvailable,
  calcDiscountAmount,
  calcSalePrice,
  calcNetPrice,
  ADD_PRODUCT_TO_CART_ERROR_MSG,
  findUnavailableBundleVariant,
  formatPriceWithoutZeros,
} from '../../scripts/utils/product-helpers';
import { addItems } from '../../scripts/cartApi';
import { sendCustomEvent } from '../../scripts/config/analytics';
import {
  initCart,
  openSideCart,
} from '../../templates/common/side-cart/side-cart';
import { calcBogoBonusProducts } from '../../scripts/utils/bogo-helpers';
import {
  ADD_TO_CART_TEXT,
  NOT_AVAILABLE_TEXT,
  PRE_ORDER_TEXT,
} from '../../scripts/config/constants';

const { products, variantsPreviewImage, variantsMeta, bogo, bundleConfig } =
  window.productCardsConfig;

const CreateProductTile = (productId) => ({
  data() {
    this.normalizedProductActive = normalizeProductConfig(products[productId]);
    this.normalizedVariantsList = this.normalizedProductActive.variants;
    const normalizedVariantActive = this.normalizedProductActive.variants[0];

    this.productTileSelector = `#product-buy-tile-dimmer-pack-${this.normalizedProductActive.id}`;

    return {
      normalizedVariantActive,
      isSpinnerActive: false,
      quantity: 1,
      errorMessage: '',
      loaded: false,
    };
  },
  mounted() {
    this.loaded = true;
  },
  computed: {
    previewImage() {
      return variantsPreviewImage[this.normalizedVariantActive.id];
    },
    variantActiveMeta() {
      const { id } = this.normalizedVariantActive;

      return variantsMeta[id];
    },
    variantActiveBundleConfig() {
      return bundleConfig[this.normalizedVariantActive.id];
    },
    colorLabel() {
      return this.normalizedVariantActive.handleizedOption1.replaceAll(
        '-',
        ' '
      );
    },
    netPrice() {
      const { normalizedVariantActive, discountPrice } = this;

      return calcNetPrice(
        normalizedVariantActive.price,
        normalizedVariantActive.compare_at_price,
        discountPrice
      );
    },
    formattedNetPrice() {
      return formatPriceWithoutZeros(this.netPrice);
    },
    discountPrice() {
      const { discountPrice } = this.variantActiveMeta;

      return discountPrice;
    },
    salePrice() {
      const { discountPrice } = this;
      const { price } = this.normalizedVariantActive;

      return calcSalePrice(price, discountPrice);
    },
    formattedSalePrice() {
      return formatPriceWithoutZeros(this.salePrice);
    },
    discountAmount() {
      const { discountPrice, normalizedVariantActive } = this;

      return calcDiscountAmount(
        normalizedVariantActive.price,
        normalizedVariantActive.compare_at_price,
        discountPrice
      );
    },
    formattedDiscountAmount() {
      const { discountAmount } = this;

      if (discountAmount) {
        return formatPriceWithoutDecimals(discountAmount);
      }

      return null;
    },
    preOrderMessage() {
      const { preOrderCollectionsText } = this.variantActiveMeta;

      return calcBundlePreOrderMessage(
        this.variantActiveBundleConfig,
        preOrderCollectionsText
      );
    },
    submitButtonText() {
      if (!this.isVariantActiveAvailable) {
        return this.variantActiveMeta.notAvailableText || NOT_AVAILABLE_TEXT;
      }

      if (this.preOrderMessage) {
        return PRE_ORDER_TEXT;
      }

      return ADD_TO_CART_TEXT;
    },
    isVariantActiveAvailable() {
      const { isVariantInStock, normalizedVariantActive, errorMessage } = this;

      const isVariantActiveInStock = isVariantInStock(normalizedVariantActive);
      const isErrorEmpty = errorMessage === '';

      return isVariantActiveInStock && isErrorEmpty;
    },
    unavailableItem() {
      return findUnavailableBundleVariant(this.variantActiveBundleConfig);
    },
  },
  methods: {
    isVariantInStock(normalizedVariant) {
      const areAllVariantsAvailable = isBundleAvailable(
        bundleConfig[normalizedVariant.id]
      );

      return normalizedVariant.available && areAllVariantsAvailable;
    },
    isActiveVariant(variantId) {
      return variantId === this.normalizedVariantActive.id;
    },
    changeActiveVariant(normalizedVariant) {
      this.normalizedVariantActive =
        normalizedVariant || this.normalizedProductActive.variants[0];
      this.errorMessage = '';
    },
    makeTooltipTextTop(normalizedVariant) {
      return `${normalizedVariant.handleizedOption1.toUpperCase()}`;
    },
    makeTooltipTextBottom(variant) {
      if (variant.available && variant.inventory_quantity < 0) {
        return `Available for Pre-Order`;
      }
      if (variant.available) {
        return ``;
      }
      return `Sold Out`;
    },
    calcVariantsBuyList() {
      const mainProducts = calcBundleVariantsForSell(
        bundleConfig[this.normalizedVariantActive.id]
      );

      const bogoProducts = calcBogoBonusProducts(
        bogo[this.normalizedVariantActive.id]
      );

      if (bogoProducts) {
        return [...bogoProducts, ...mainProducts];
      }

      return mainProducts;
    },
    async submitProductForm(e) {
      e.preventDefault();

      this.isSpinnerActive = true;
      await initCart();

      const items = this.calcVariantsBuyList();

      try {
        await addItems(items);

        const { sideCart } = window;

        sideCart.updateView(null, openSideCart);

        const addedVariantsIds = items.map((item) => item.id);

        addedVariantsIds.forEach((addedVariantId) => {
          sendCustomEvent({
            category: 'Cart',
            action: 'Add',
            label: addedVariantId,
          });
        });
      } catch (err) {
        if (err.headers) {
          err.json().then((body) => {
            this.errorMessage = body.message;
          });
        } else {
          this.errorMessage = ADD_PRODUCT_TO_CART_ERROR_MSG;
        }
        console.error(err);
      }

      this.isSpinnerActive = false;
    },
    openWishListModal() {
      if (this.unavailableItem) {
        window.productWishListModal?.updateModalState({
          newVariantId: this.unavailableItem.id,
        });
      }
      window.productWishListModal?.openModal();
    },
  },
});

export const initProductBuyTileDimmerPack = (productId) => {
  const productTile = CreateProductTile(productId);

  if (productTile) {
    new Vue(productTile).$mount(`#product-buy-tile-dimmer-pack-${productId}`);
  }
};
